import React from 'react';
import team1 from '../../assets/images/team_01.webp';
import team2 from '../../assets/images/team_02.webp';
import team3 from '../../assets/images/team_03.webp';
import { siteCopy } from '../../content/siteCopy';

const principleImages = [team1, team2, team3];

const Expert = () => {
  const { principles } = siteCopy.aboutUs;

  return (
    <>
      <section className="row_am experts_team_section">
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
            <span className="title_badge">{principles.badge}</span>
            <h2>{principles.title}</h2>
            <p>{principles.intro}</p>
          </div>
          <div className="row">
            {principles.items.map((item, index) => (
              <div
                key={item.title}
                className="col-md-4"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <div className="experts_box">
                  <img
                    className="principle_icon"
                    src={principleImages[index]}
                    alt=""
                    aria-hidden="true"
                  />
                  <div className="text">
                    <h6>{item.title}</h6>
                    <span>{item.body}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Expert;
